import { useState } from "react";
import { useNavigate } from "react-router";
import { Button, Typography, TextField } from "@mui/material";

export function PetProfileSearch() {
  const navigate = useNavigate();
  const [id, setId] = useState("");

  const onSubmit = (event: any) => {
    event.preventDefault();
    navigate(`/pet-medical-records/${id}`);
    return false;
  };

  return (
    <form onSubmit={onSubmit}>
      <Typography
        variant="h4"
        component="h4"
        sx={{ mb: 2, fontWeight: "medium" }}
      >
        The Kin - Pet Medical Records Search
      </Typography>
      <h4>Enter Pet ID:</h4>
      <TextField
        size="small"
        type="text"
        value={id}
        onChange={(e) => setId(e.target.value)}
      />
      <Button variant="contained" type="submit" sx={{ ml: 2 }}>
        Go
      </Button>
    </form>
  );
}
